/** @format */

import React from "react";

//react-slick
import Slider from "react-slick";

//img
import RightArrow from "../../img/RightArrow.svg";
import LeftArrow from "../../img/LeftArrow.svg";
import Member1 from "../../img/AboutUs/About us 1.webp";
import Member2 from "../../img/AboutUs/About us 2.webp";
import Member3 from "../../img/AboutUs/About us 3.webp";
import Member4 from "../../img/AboutUs/About us 4.webp";
import Member5 from "../../img/AboutUs/About us 5.webp";
import Member6 from "../../img/AboutUs/About us 6.webp";
import Member7 from "../../img/AboutUs/About us 7.webp";
import Member8 from "../../img/AboutUs/About us 8.webp";
import Member9 from "../../img/AboutUs/About us 9.webp";
import Member10 from "../../img/AboutUs/About us 10.webp";
import Member11 from "../../img/AboutUs/About us 11.webp";
import Member12 from "../../img/AboutUs/About us 12.webp";
import Member13 from "../../img/AboutUs/About us 13.webp";
import Member14 from "../../img/AboutUs/About us 14.webp";
import Member15 from "../../img/AboutUs/About us 15.webp";
import Member16 from "../../img/AboutUs/About us 16.webp";
import Member17 from "../../img/AboutUs/About us 17.webp";
import Member18 from "../../img/AboutUs/About us 18.webp";
import Member19 from "../../img/AboutUs/About us 19.webp";
import Member20 from "../../img/AboutUs/About us 20.webp";
import Member21 from "../../img/AboutUs/About us 21.webp";
import Member22 from "../../img/AboutUs/About us 22.webp";

//json2mq
import json2mq from "json2mq";

//material ui
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";

const useStyles = (theme, isMobile) => ({
  container: {
    width: "100%",
    flexWrap: "wrap",
  },
  titleContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "40px",
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    backgroundColor: theme.palette.red.main,
  },
  sliderContainer: {
    width: "95%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "55px 0 146px",
  },
  slider: {
    width: "100%",
    height: "fit-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  span: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  arrow: {
    color: theme.palette.grey.main,
    fontSize: "30px",
    fontWeight: "bold",
  },
  typography: {
    section: {
      fontSize: isMobile ? "14px" : "16px",
      fontWeight: "bold",
      letterSpacing: "2px",
      color: theme.palette.red.main,
      marginTop: isMobile ? "127px" : "0",
    },
    sectionDescription: {
      fontSize: { sm: "65px", xs: "32px" },
      fontFamily: theme.typography.montserrat.bold,
      color: theme.palette.blue.main,
      marginTop: { sm: "16px", xs: "25px" },
    },
    info: {
      fontSize: { sm: "65px", xs: "18px" },
      fontFamily: theme.typography.montserrat.regular,
      width: { xs: "280px" },
      color: theme.palette.blue.main,
      marginTop: { sm: "16px", xs: "27px" },
    },
  },
});

function Arrow(props) {
  const theme = useTheme();
  const classes = useStyles(theme);
  let className = props.type === "next" ? "nextArrow" : "prevArrow";
  className += " arrow";

  const char =
    props.type === "next" ? (
      <img
        src={RightArrow}
        alt="flecha"
        style={{
          ...classes.arrow,
          marginLeft: "15px",
        }}
      />
    ) : (
      <img
        alt="flecha"
        src={LeftArrow}
        style={{ ...classes.arrow, marginRight: "15px" }}
      />
    );

  return (
    <span className={className} onClick={props.onClick} style={classes.span}>
      {char}
    </span>
  );
}

const Memebers = () => {
  const isMobile = useMediaQuery("(max-width:899px)");

  const theme = useTheme();
  const classes = useStyles(theme, isMobile);

  const members = [
    Member1,
    Member2,
    Member3,
    Member4,
    Member5,
    Member6,
    Member7,
    Member8,
    Member9,
    Member21,
    Member22,
    Member10,
    Member11,
    Member12,
    Member13,
    Member14,
    Member15,
    Member16,
    Member17,
    Member18,
    Member19,
    Member20,
  ];

  const md = useMediaQuery(
    json2mq({
      maxWidth: 1100,
    })
  );
  const lg = useMediaQuery(
    json2mq({
      maxWidth: 1640,
    })
  );
  const xl = useMediaQuery(
    json2mq({
      minWidth: 1641,
    })
  );

  const stylesHelper = () => {
    if (md)
      return {
        img: {
          width: "260px",
          margin: "15px",
        },
      };
    if (lg)
      return {
        img: {
          width: "300px",
          margin: "37.5px",
        },
      };
    if (xl)
      return {
        img: {
          width: "349px",
          margin: "47.5px",
        },
      };
  };

  return isMobile ? (
    <>
      <Typography sx={classes.typography.section}>NUESTRO EQUIPO</Typography>
      <Typography sx={classes.typography.sectionDescription}>
        Staff P5
      </Typography>
      <div style={classes.sliderContainer}>
        <Slider
          slidesToShow={1}
          style={classes.slider}
          nextArrow={<Arrow type="next" />}
          prevArrow={<Arrow type="prev" />}
          autoplay={true}
          speed={3500}
          autoplaySpeed={0}
          cssEase="linear"
        >
          {members.map((img, index) => {
            return (
              <Box key={index}>
                <img
                  src={img}
                  alt="member"
                  style={{ width: "251.3px", margin: "auto" }}
                />
              </Box>
            );
          })}
        </Slider>
      </div>
    </>
  ) : (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={classes.titleContainer}>
        <div style={classes.line}></div>
        <Typography sx={classes.typography.section}>NUESTRO EQUIPO</Typography>
      </Box>
      <Typography sx={classes.typography.sectionDescription}>
        Staff P5
      </Typography>
      <Box sx={classes.container}>
        {members.map((Member, index) => {
          return (
            <img
              src={Member}
              key={index}
              alt=""
              style={stylesHelper() && stylesHelper().img}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default Memebers;
